import { withInstall } from "../utils/index.mjs";
import _Step from "./Step.mjs";
const Step = withInstall(_Step);
var stdin_default = Step;
export {
  Step,
  stdin_default as default
};
